@import '../general';
@import 'breadcrumb';

li :where(button, a) {
  @extend .elm-link;
}
